
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termini",
      function () {
        return require("private-next-pages/termini.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termini"])
      });
    }
  